import { FilterSettingIcon, RefreshIcon } from "@/assets/icons";
import { Button } from "@/components/ui/button";
import { PoiBrandGroupedByCategory } from "@/types/poiParameter";

import { CategoryItem } from "./CategoryItem";

interface CategorySelectedListProps {
  selectedBrands: PoiBrandGroupedByCategory;
  sidebarExpandedCategories: Record<string, boolean>;
  onToggleExpand: (key: string) => void;
  onDeleteAllInCategory: (key: string) => void;
  onDeleteSingleItem: (key: string, brandCode: string) => void;
  onContinue?: () => void;
  isContinueDisabled?: boolean;
  selectedCategories: Set<string>;
  isLoading?: boolean;
}

export const CategorySelectedList = ({
  selectedBrands,
  sidebarExpandedCategories,
  onToggleExpand,
  onDeleteAllInCategory,
  onDeleteSingleItem,
  onContinue,
  isContinueDisabled,
  selectedCategories,
  isLoading
}: CategorySelectedListProps) => {
  const hasSelectedItems = Object.keys(selectedBrands).length > 0;
  const orderMap = new Map([...selectedCategories].map((key, i) => [key, i]));
  const categories = Object.entries(selectedBrands).sort(
    ([a], [b]) => (orderMap.get(a) ?? Infinity) - (orderMap.get(b) ?? Infinity)
  );

  return (
    <div className="flex-1 bg-white border border-gainsboro rounded-xl overflow-hidden flex flex-col p-4 gap-3">
      <h3 className="text-txtHeading font-semibold">Category Selected</h3>

      {hasSelectedItems ? (
        <div className="flex-1 overflow-y-auto space-y-4 custom-scrollbar">
          {categories.map(([key, selection]) => (
            <CategoryItem
              key={key}
              categoryKey={key}
              categoryLabel={selection.categoryName}
              items={selection.brands}
              isExpanded={sidebarExpandedCategories[key] ?? false}
              onToggleExpand={onToggleExpand}
              onDeleteAll={onDeleteAllInCategory}
              onDeleteItem={onDeleteSingleItem}
            />
          ))}
        </div>
      ) : (
        <div className="flex-1 flex flex-col items-center justify-center gap-1">
          <FilterSettingIcon className="w-8 h-8 fill-silver" />
          <p className="text-xs text-gray-400">
            Select data from group and data
          </p>
        </div>
      )}

      <div>
        <Button
          className="w-full py-3 rounded-lg text-sm font-semibold"
          onClick={onContinue}
          disabled={isContinueDisabled || isLoading}
        >
          {isLoading ? (
            <RefreshIcon className="animate-spin fill-white" />
          ) : (
            "Continue"
          )}
        </Button>
      </div>
    </div>
  );
};
